import { DocumentsPanel } from "@/components/DocumentsPanel";
import { useAuth } from "@/context/AuthContext";

export default function Documents() {
  const { user } = useAuth();
  return (
    <div>
      <div className="mb-8">
        <div className="overline mb-2">Secure Area</div>
        <h1 className="font-dash text-3xl">Confidential Documents</h1>
        <p className="text-zinc-500 mt-2 text-sm">Upload and exchange confidential files with Tactis. All transfers are encrypted and access-controlled.</p>
      </div>
      <DocumentsPanel />
    </div>
  );
}
